// extracted by mini-css-extract-plugin
export default {"wrapper":"image__wrapper___qDPlU","placeholder":"image__placeholder___zxAnd"};